import {Column} from '../../../stores/Form/Column';
import {v4 as uuidv4} from 'uuid';
import {Operator} from '../../../_legacy/Searches/consts/operators';
import {getBaseColumnType} from '../../AppSearches/types/column';
import {priority} from '@priority-software/priority-proto-api/lib';
import {IFilter} from '../../../stores/Form/Filter';
import {DateEnum} from '../../AppSearches/types/filters';
import {getOperatorFromCondition} from '../common/getOperatorFromCondition';
import {deSerializeFilterValues} from '../common/serializeFilterValues';
import {defaultOperators} from '../../AppSearches/types/operator';

export const OperatorMapping = {
    '<': priority.netitems.shared.ComparisonOperator.Lt,
    '<=': priority.netitems.shared.ComparisonOperator.Le,
    '>': priority.netitems.shared.ComparisonOperator.Gt,
    '>=': priority.netitems.shared.ComparisonOperator.Ge,
    '=': priority.netitems.shared.ComparisonOperator.Eq,
    '<>': priority.netitems.shared.ComparisonOperator.Ne
};

export function stringToOperator(
    operatorString: string
): priority.netitems.shared.ComparisonOperator {
    return OperatorMapping[operatorString];
}

export function isValidOperator(value: string): boolean {
    return OperatorMapping[value] !== undefined;
}

export function isOperatorField(searchMode: boolean, rowIndex: number): boolean {
    return searchMode && rowIndex % 2 === 0;
}

export const getDefaultOperatorFromColumnType = ({Type, Zoom, Relcol}: Column) => {
    if (!Relcol && Zoom === priority.netitems.form.ZoomType.SelectZoom) {
        return Operator.Equals;
    }
    return defaultOperators[getBaseColumnType(Type)];
};

export const isActiveFilter = (column: Column) => {
    const filters = column.parentForm.filters;
    if (!filters) return false;
    return Boolean(filters.find(filter => filter?.Condition[0]?.ColumnID === column.ID));
};

export const createNewFilterCondition = (
    column: Column,
    conditionData?: {
        Values?: string[];
        Operator?: priority.netitems.shared.ComparisonOperator | null;
        DateEnum?: DateEnum[] | null;
        IgnoreCase?: boolean;
        Id?: string;
    }
) => {
    return {
        columnName: column.Name,
        columnID: column.ID,
        operator: conditionData
            ? getOperatorFromCondition(conditionData, column.Type)
            : getDefaultOperatorFromColumnType(column),
        values: conditionData
            ? [
                  ...deSerializeFilterValues(
                      getOperatorFromCondition(conditionData, column.Type),
                      conditionData.Values,
                      getBaseColumnType(column.Type)
                  )
              ]
            : [],
        dateEnum: (conditionData?.DateEnum as DateEnum[]) || null,
        ignoreCase: conditionData ? conditionData.IgnoreCase : undefined,
        type: getBaseColumnType(column.Type),
        origType: column.Type,
        title: column.Title,
        id: conditionData?.Id || uuidv4()
    };
};

export const patchFetchConditions = (column: Column, filter?: IFilter) => {
    if (filter) {
        return filter.Condition.map(cond => createNewFilterCondition(column, cond));
    }
    return [createNewFilterCondition(column)];
};
